import Divider from '@mui/material/Divider';
import { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Container from '/@/components/container';
import HeaderSteps from '/@/components/crop-monitoring/header-steps';
import InfoHeader from '/@/components/crop-monitoring/info-header';
import CropMonitoringStepper from '/@/components/crop-monitoring/stepper';
import { useFieldById } from '/@/hooks/fields';
import { setField } from '/@/store/crop-monitoring/actions';
import { getField } from '/@/store/crop-monitoring/selectors';
import useIsMobile from '/@/utils/hooks/is-mobile';
import { reverse } from '/@/utils/router';
import styles from '../../styles.module.css';

const CropMonitoringCorn = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const fieldIdFromQuery = new URLSearchParams(window.location.search).get('fieldId');
    const fieldId = useSelector(getField);
    const fieldQuery = useFieldById({ id: fieldId }, { enabled: !!fieldId });
    const isMobile = useIsMobile();

    if (fieldIdFromQuery && !fieldId) {
        dispatch(setField(fieldIdFromQuery));
    }

    const handleNext = () => {
        navigate(reverse('cropMonitoring.CropMonitoringStepperMobile'));
    };

    return (
        <Fragment>
            {fieldId && (
                <Fragment>
                    <Container classNameRoot={styles.container}>
                        <InfoHeader field={fieldQuery.data} />
                    </Container>
                    <Divider variant='middle' />
                </Fragment>
            )}
            {isMobile ? (
                <Fragment>
                    <Container classNameRoot={styles.root}>
                        <HeaderSteps next={handleNext} isMobile={isMobile} />
                    </Container>
                </Fragment>
            ) : (
                <Fragment>
                    <Container classNameRoot={styles.containerRoot}>
                        <HeaderSteps />
                    </Container>
                    <Divider variant='middle' />
                    <Container>
                        <CropMonitoringStepper />
                    </Container>
                </Fragment>
            )}
        </Fragment>
    );
};

export default CropMonitoringCorn;
